
/**
 * Module dependencies.
 */

import { Button, ButtonProps } from './button';
import { ForwardedRef, forwardRef } from 'react';
import { useFormState } from '@seegno/react-forms';

/**
 * `Props` type.
 */

type Props = Omit<ButtonProps, 'isLoading' | 'type'>;

/**
 * `SubmitButton` component.
 */

function SubmitButton(props: Props, ref: ForwardedRef<HTMLButtonElement>): JSX.Element {
  const { children, disabled, ...rest } = props;
  const { isSubmitting } = useFormState();

  return (
    <Button
      {...rest}
      disabled={disabled || isSubmitting}
      isLoading={isSubmitting}
      ref={ref}
      type={'submit'}
    >
      {children}
    </Button>
  );
}

/**
 * Forwarded `SubmitButton`.
 */

const ForwardedSubmitButton = forwardRef<HTMLButtonElement, Props>(SubmitButton);

/**
 * Export `SubmitButton` component.
 */

export { ForwardedSubmitButton as SubmitButton };
